import { IonCard, IonActionSheet } from "@ionic/react";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { IoEllipsisHorizontal } from "react-icons/io5";
import { useDispatch, useSelector } from "react-redux";
import {
  getTrends,
  deleteTrend as deleteTrendAction,
} from "../../../redux/actions/postActions";
import "./TrendsCard.css";
import { getHashtagMetadata } from "../../../utils/hashtagMetadata";
import CommunityStats from "./CommunityStats";
import EditCommunityModal from "../../modal/EditCommunityModal";
import { closeOutline, settingsOutline, trashOutline } from "ionicons/icons";

function TrendsCard() {
  const { t } = useTranslation();

  const postState = useSelector((state) => state.post);
  const currentProfile = useSelector((state) => state.currentProfile?.data);
  const { trends } = postState;
  const dispatch = useDispatch();

  const [showActionSheet, setShowActionSheet] = useState(false);
  const [selectedTrend, setSelectedTrend] = useState(null);
  const [showEditModal, setShowEditModal] = useState(false);

  useEffect(() => {
    dispatch(getTrends());
  }, [dispatch]);

  const openActionSheet = (e, trend) => {
    e.preventDefault();
    e.stopPropagation();
    setSelectedTrend(trend);
    setShowActionSheet(true);
  };

  const handleDelete = () => {
    if (!selectedTrend) return;
    const tagToDelete = selectedTrend.name?.replace(/^#/, "");
    if (tagToDelete) {
      dispatch(deleteTrendAction(tagToDelete));
    }
    setShowActionSheet(false);
  };

  const handleEdit = () => {
    setShowActionSheet(false);
    setShowEditModal(true);
  };

  return (
    <>
      {trends ? (
        trends.map((trend, idx) => {
          const tag = trend.tag.slice(1);
          const {
            title: displayName,
            desc,
            banner,
          } = getHashtagMetadata(tag, trend.hashtag);

          const isAdmin = !!currentProfile?.isAdmin;

          const isOwner =
            currentProfile?._id &&
            trend.hashtag?.owner &&
            currentProfile._id.toString() === trend.hashtag.owner.toString();
          const canAction = isAdmin || isOwner || trend?.canDelete;

          return (
            <div key={idx} className="trends-card-container">
              <IonCard
                routerLink={`/hashtag/${tag}`}
                className="trends-card ion-padding"
              >
                <div className="trends-card-content">
                  <div className="trends-card-header">
                    {banner && (
                      <div className="trends-card-banner">
                        <img src={banner} alt={trend.tag} />
                      </div>
                    )}
                    <div className="trends-card-info">
                      <div className="trends-card-title-row">
                        <h3 className="trends-card-title">{displayName}</h3>
                        {canAction && (
                          <button
                            aria-label="Options"
                            className="trend-delete-btn"
                            onClick={(e) => openActionSheet(e, trend.hashtag)}
                            title="Options"
                          >
                            <IoEllipsisHorizontal size={18} />
                          </button>
                        )}
                      </div>
                      <CommunityStats
                        postCount={trend.count}
                        memberCount={trend.userCount}
                        className="trends-card-stats"
                      />
                    </div>
                  </div>
                  {desc && (
                    <>
                      <hr className="trends-card-divider" />
                      <p className="trends-card-description">
                        {desc.replace("Course Code: ", "").split("\n")[0]}
                      </p>
                    </>
                  )}
                </div>
              </IonCard>
            </div>
          );
        })
      ) : (
        <p>{t("trends.noTrends")}</p>
      )}

      {/* Options ActionSheet */}
      <IonActionSheet
        isOpen={showActionSheet}
        onDidDismiss={() => setShowActionSheet(false)}
        header="Community Options"
        buttons={[
          {
            text: "Edit",
            handler: handleEdit,
            icon: settingsOutline,
          },
          {
            text: "Delete",
            handler: handleDelete,
            icon: trashOutline,
          },
          {
            text: "Cancel",
            role: "cancel",
            handler: () => setShowActionSheet(false),
            icon: closeOutline,
          },
        ]}
      />

      {/* Edit Modal */}
      <EditCommunityModal
        isOpen={showEditModal}
        onClose={() => setShowEditModal(false)}
        communityData={selectedTrend}
      />
    </>
  );
}

export default TrendsCard;

